const Biases = {
  performance: {
    title: "Sesgo de Desempeño",
    translated: "Performance Bias",
    description:
      "Es la asunción sobre las habilidades de los hombres y las mujeres. Tendemos a subestimar a las mujeres y sobreestimar a los hombres.",
  },
  likeability: {
    title: "Sesgo de Simpatía",
    translated: "Likeability Bias",
    description:
      "Esperamos que los hombres sean asertivos, lo cual es natural cuando lideran. De las mujeres esperamos que sean tiernas y simples, entonces si son asertivas nos agradan menos.",
  },
  maternal: {
    title: "Sesgo Maternal",
    translated: "Maternal Bias",
    description:
      "La maternidad provoca falsas asunciones de que las mujeres están menos comprometidas con su carrera e incluso son menos competentes.",
  },
  unconscious: {
    title: "Sesgo Inconsciente",
    translated: "Unconscious Bias",
    description:
      "Son “atajos” mentales que nuestro cerebro hace para que el mundo alrededor nuestro tenga sentido. Aún es común que la gente experimente discriminación abierta en base a su raza, genero, sexualidad entre otros.",
  },
  attribution: {
    title: "Sesgo de Atribución",
    translated: "Attribution Bias",
    description:
      "Este sesgo está conectado con el sesgo de desempeño. A las mujeres se les ve menos competentes que a los hombres, por lo cual tendemos a darle menos crédito por sus logros y más culpa por sus errores.",
  },
  affinity: {
    title: "Sesgo de Afinidad",
    translated: "Affinity Bias",
    description:
      "Es lo que suena, solemos rodearnos de gente que es como nosotros en apariencia, creencias y antecedentes. Y tal vez evitamos o sentimos rechazo hacia una persona diferente a nosotros.",
  },
};

export default Biases;
